import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false,
    isSuccess: false
};
var createPermissionSlice = createSlice({
    name: "createPermission",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
            state.isSuccess = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isSuccess: true,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true,
                isSuccess: false
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _createPermissionSlice_actions = createPermissionSlice.actions;
export var fetchData = _createPermissionSlice_actions.fetchData, fetchDataSuccess = _createPermissionSlice_actions.fetchDataSuccess, fetchDataFailure = _createPermissionSlice_actions.fetchDataFailure, resetState = _createPermissionSlice_actions.resetState;
export default createPermissionSlice.reducer;
